/* unplugin-vue-components disabled */import { render } from "./contact-search.vue?vue&type=template&id=06c790c4&scoped=true"
import script from "./contact-search.vue?vue&type=script&lang=js"
export * from "./contact-search.vue?vue&type=script&lang=js"

import "./contact-search.vue?vue&type=style&index=0&id=06c790c4&lang=stylus"
import "./contact-search.vue?vue&type=style&index=1&id=06c790c4&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c790c4"],['__file',"src/components/search-dropdown/contact-search.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "06c790c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('06c790c4', __exports__)) {
    api.reload('06c790c4', __exports__)
  }
  
  module.hot.accept("./contact-search.vue?vue&type=template&id=06c790c4&scoped=true", () => {
    api.rerender('06c790c4', render)
  })

}


export default __exports__